import { useRecoilValue } from 'recoil';
import { beaconSelector } from '../recoil/selector';
import useBeacon from '../hooks/useBeacon';
import { useEffect } from 'react';
import { PAGE_NM } from '../types/types';

const useWorking = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.WORKING,
  });
  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  return {};
};

export default useWorking;
